<div class="flex justify-center mt-3" style="height: 70%;">
    <ag-grid-angular style="width: 100%; " class="ag-theme-alpine" [columnDefs]="plotColumnDefs"
        [defaultColDef]="defaultColDef" [rowData]="plotCodes" [gridOptions]="gridOptions"
        >
    </ag-grid-angular>
</div>